import { render, staticRenderFns } from "./StaffDropTree.vue?vue&type=template&id=cbae0fa6&"
import script from "./StaffDropTree.vue?vue&type=script&lang=js&"
export * from "./StaffDropTree.vue?vue&type=script&lang=js&"
import style0 from "./StaffDropTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports